import { render, staticRenderFns } from "./teammates.vue?vue&type=template&id=09c89f54&scoped=true&"
import script from "./teammates.vue?vue&type=script&lang=js&"
export * from "./teammates.vue?vue&type=script&lang=js&"
import style0 from "./teammates.vue?vue&type=style&index=0&id=09c89f54&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c89f54",
  null
  
)

export default component.exports